/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * StavertonAPI
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  GetZoneParams,
  ZoneGetResponse,
  ZoneListResponse,
  ZoneUpdateRequest,
  ZoneUpdateResponse
} from './index.schemas';

import { useCustomInstance } from '../staverton.openapi.axios';





export const useListZonesHook = () => {
        const listZones = useCustomInstance<ZoneListResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return listZones(
          {url: `/Zone/List`, method: 'GET', signal
    },
          );
        }, [listZones])
      }
    

export const getListZonesQueryKey = () => {
    return [`/Zone/List`] as const;
    }

    
export const useListZonesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useListZonesHook>>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListZonesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListZonesQueryKey();

  const listZones =  useListZonesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListZonesHook>>>> = ({ signal }) => listZones(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListZonesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListZonesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListZonesHook>>>>
export type ListZonesQueryError = unknown


export function useListZones<TData = Awaited<ReturnType<ReturnType<typeof useListZonesHook>>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListZonesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListZonesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListZonesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListZones<TData = Awaited<ReturnType<ReturnType<typeof useListZonesHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListZonesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListZonesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListZonesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListZones<TData = Awaited<ReturnType<ReturnType<typeof useListZonesHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListZonesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListZones<TData = Awaited<ReturnType<ReturnType<typeof useListZonesHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListZonesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListZonesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const useGetZoneHook = () => {
        const getZone = useCustomInstance<ZoneGetResponse>();

        return useCallback((
    params?: GetZoneParams,
 signal?: AbortSignal
) => {
        return getZone(
          {url: `/Zone/Get`, method: 'GET',
        params, signal
    },
          );
        }, [getZone])
      }
    

export const getGetZoneQueryKey = (params?: GetZoneParams,) => {
    return [`/Zone/Get`, ...(params ? [params]: [])] as const;
    }

    
export const useGetZoneQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetZoneHook>>>, TError = unknown>(params?: GetZoneParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetZoneHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetZoneQueryKey(params);

  const getZone =  useGetZoneHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetZoneHook>>>> = ({ signal }) => getZone(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetZoneHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetZoneQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetZoneHook>>>>
export type GetZoneQueryError = unknown


export function useGetZone<TData = Awaited<ReturnType<ReturnType<typeof useGetZoneHook>>>, TError = unknown>(
 params: undefined |  GetZoneParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetZoneHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetZoneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetZoneHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetZone<TData = Awaited<ReturnType<ReturnType<typeof useGetZoneHook>>>, TError = unknown>(
 params?: GetZoneParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetZoneHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetZoneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetZoneHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetZone<TData = Awaited<ReturnType<ReturnType<typeof useGetZoneHook>>>, TError = unknown>(
 params?: GetZoneParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetZoneHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetZone<TData = Awaited<ReturnType<ReturnType<typeof useGetZoneHook>>>, TError = unknown>(
 params?: GetZoneParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetZoneHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetZoneQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const useUpdateZoneHook = () => {
        const updateZone = useCustomInstance<ZoneUpdateResponse>();

        return useCallback((
    zoneUpdateRequest: ZoneUpdateRequest,
 ) => {
        return updateZone(
          {url: `/Zone/Update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: zoneUpdateRequest
    },
          );
        }, [updateZone])
      }
    


export const useUpdateZoneMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateZoneHook>>>, TError,{data: ZoneUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateZoneHook>>>, TError,{data: ZoneUpdateRequest}, TContext> => {

const mutationKey = ['updateZone'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updateZone =  useUpdateZoneHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateZoneHook>>>, {data: ZoneUpdateRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateZone(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateZoneMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateZoneHook>>>>
    export type UpdateZoneMutationBody = ZoneUpdateRequest
    export type UpdateZoneMutationError = unknown

    export const useUpdateZone = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateZoneHook>>>, TError,{data: ZoneUpdateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateZoneHook>>>,
        TError,
        {data: ZoneUpdateRequest},
        TContext
      > => {

      const mutationOptions = useUpdateZoneMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    